import React from 'react';
import { useSelector } from 'react-redux';
import { Routes, Route, useParams, useLocation } from 'react-router-dom';
import CourseAnnouncements from 'Screens1/Instructor/Course/Interactions/Announcements';
import CourseAnnouncementsV2 from 'Screens1/Instructor/Course/Interactions/AnnouncementsV2';
import CourseAnnouncementsStudent from 'Screens1/Student/Course/Interactions/Announcements';
import { useFeatureFlags } from 'hooks/useFeatureFlags';
import log from "loglevel"

const AnnouncementsNavigation = () => {
    const params = useParams();
    const location = useLocation();
    const state = useSelector(state => state);
    const { enableInstructorV2 } = useFeatureFlags();

    const path = location.pathname;
    let { courseId } = params;
    log.log("AnnouncementsNavigation", path);

    const isAuthenticated = state.userInfo.token !== null;
    const mode = state.userInfo.mode;

    // Select instructor component based on feature flag
    const InstructorComponent = enableInstructorV2 ? CourseAnnouncementsV2 : CourseAnnouncements;

    switch (mode) {
        case 'I':
            return (
                <Routes>
                    <Route path="" element={<InstructorComponent courseId={courseId} />} />
                </Routes>
            );

        default:
            return (
                <Routes>
                    <Route path="" element={<CourseAnnouncementsStudent />} />
                </Routes>
            );
    }
};

export default AnnouncementsNavigation;
